module.exports = __webpack_public_path__ + "assets/eb45f237e33b8c943ff7626fa1604dd4.mp3";